import React from 'react';
import { ExternalLink, Star } from 'lucide-react';

interface ToolCardProps {
  icon: string;
  name: string;
  description: string;
  url: string;
  category: string;
  isNew?: boolean;
  isHot?: boolean;
  isGrowing?: boolean;
  growingText?: string;
  comingSoonText?: string;
}

export default function ToolCard({ icon, name, description, url, category, isNew, isHot, isGrowing, growingText, comingSoonText }: ToolCardProps) {
  const isClickable = !isGrowing;

  return (
    <div
      className={isClickable
        ? "group bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border border-gray-100 dark:border-gray-700 block"
        : "bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-gray-700 block"
    }
    >
      {/* 顶部标签 */}
      <div className="flex items-center gap-2 mb-4">
        <span className="text-xs font-medium text-[#165DFF] bg-blue-50 dark:bg-blue-900/20 px-2 py-1 rounded-full">
          {category}
        </span>
        {isNew && (
          <span className="text-xs font-medium text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-900/20 px-2 py-1 rounded-full">
            NEW
          </span>
        )}
        {isHot && (
          <span className="text-xs font-medium text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-900/20 px-2 py-1 rounded-full flex items-center gap-1">
            <Star className="w-3 h-3" />
            HOT
          </span>
        )}
        {isGrowing && (
          <span className="text-xs font-medium text-white bg-[#90EE90]/80 dark:bg-[#90EE90]/60 px-2 py-1 rounded-full">
            {growingText || '生长中'}
          </span>
        )}
      </div>

      {/* 图标和名称 */}
      <div className="flex items-start gap-4 mb-3">
        <div className="text-4xl flex-shrink-0">{icon}</div>
        <div className="flex-1 min-w-0">
          <h3 className={`font-bold text-lg text-gray-800 dark:text-gray-100 ${isClickable ? 'group-hover:text-[#165DFF]' : ''} transition-colors mb-2`}>
            {name}
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 line-clamp-2 leading-relaxed">
            {description}
          </p>
        </div>
      </div>

      {/* 底部链接提示 */}
      <div className="mt-4 pt-3 border-t border-gray-100 dark:border-gray-700">
        {isClickable ? (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-xs text-gray-400 dark:text-gray-500 hover:text-[#165DFF] transition-colors"
          >
            <ExternalLink className="w-4 h-4" />
            <span>点击访问</span>
          </a>
        ) : (
          <div className="flex items-center gap-2 text-xs text-gray-300 dark:text-gray-600">
            <span>{comingSoonText || '敬请期待'}</span>
          </div>
        )}
        {/* Creator info */}
        <div className="text-[10px] text-gray-400 dark:text-gray-500 mt-2 text-right">
          Created by Douya
        </div>
      </div>
    </div>
  );
}
